import { Page } from '../../types/Page';

export const getCurrentPage = (page: string): page is Page => window.location.pathname.startsWith(page);

export const isHomePage = (): boolean => window.location.pathname === '/';
